import ky from "ky";
const api = ky.create({
  prefixUrl: /*"http://0.0.0.0:5000/api" */ "https://api.sitimm.org/api",
});

export default api;
